import TextField, {TextFieldProps} from '@material-ui/core/TextField'
import {useEvent} from 'Event/EventProvider'
import {MailchimpTag} from 'Event/mailchimp'
import {onChangeStringHandler} from 'lib/dom'
import React from 'react'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'

export default function MailchimpTagInput(
  props: Omit<TextFieldProps, 'value' | 'onChange' | 'label'> & {
    onChange: (tag: MailchimpTag | null) => void
    value?: MailchimpTag | null
    inputVariant?: 'filled' | 'standard' | 'outlined'
    label?: string
  },
) {
  const {
    disabled,
    value,
    onChange,
    error,
    label,
    inputVariant,
    ...textFieldProps
  } = props
  const {event} = useEvent()

  const name = value?.name || ''

  if (!event.has_mailchimp) {
    return null
  }

  return (
    <IntegrationTagField>
      <TextField
        value={name}
        label={label ?? 'Mailchimp Tag'}
        variant={inputVariant ?? 'outlined'}
        fullWidth
        inputProps={{
          'aria-label': 'mailchimp tag',
        }}
        onChange={onChangeStringHandler((name) => onChange({name}))}
        disabled={disabled}
        error={Boolean(error)}
        helperText={error}
        {...textFieldProps}
      />
    </IntegrationTagField>
  )
}
